<template lang="html">
  <div>
    <v-dialog
      v-model="AlbumsDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
    <v-overlay :value="progress">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-card :style="stylechat">
      <v-layout row wrap justify-center align-center class="mt-0 pl-3 pr-3">
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pl-2 pr-0 pt-3 pb-0 cursor"
          @click="close()"
        >
          <v-icon style="font-size: 30px !important;">mdi-chevron-left</v-icon>
        </v-col>
        <v-col
          cols="8"
          justify="center"
          align="center"
          class="pa-0 pt-3"
        >
          <span class="tab-title">{{$t('RightSide.menu.album')}}</span>
        </v-col>
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pr-2 pl-0 pt-0 pb-0"
          >
        </v-col>
      </v-layout>
      <v-divider class="mt-4 mb-2"></v-divider>
      <div class="pt-3 pl-5 pr-5 pb-2 list-overflow" id="myscrollAlbumChat" v-on:scroll="scrollFunction">
        <v-row class="justify-center align-center" v-if="list_albums.length === 0" style="height: 80vh;">
          <v-col cols="12" align="center" justify="center" class="col-no-media-not-active">
            <span>{{$t('Dialog.album.noDataAlbum')}}</span>
          </v-col>
        </v-row>
        <v-col v-else cols="12" v-for="(item, index) in list_albums" :key="item._id" justify="end" v-if="item.state.status === 'active'">
          <v-row @click="openDialog(item, index, 'detail-album')" v-if="item.information.length == 0">
            <v-col cols="12" align="center" justify="center" class="col-no-media-not-active">
              <span>{{$t('Dialog.album.noImageAlbum')}}</span>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col
              v-for="(data, i) in item.information"
              :key="i"
              class="d-flex child-flex pa-0"
              :cols="item.information.length == 1 ? '12' : '6'"
              v-if="i <= 3 && data.status === 'active'"
              @click="openDialog(item, index, 'detail-album')"
            >
              <v-img
                :src="data.link"
                :lazy-src="data.link"
                aspect-ratio="1"
                class="grey lighten-2"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
          </v-row>
          <v-row align-center class="pl-1 mb-5">
            <h3 class="mb-0 mt-2 text-overflow-link" @click="openDialog(item, index, 'detail-album')">{{item.albums_name}}</h3>
            <p class="mb-0 mt-2 ml-2" @click="openDialog(item, index, 'detail-album')">({{item.information.length}})</p>
            <v-spacer @click="openDialog(item, index, 'detail-album')"></v-spacer>
            <v-btn color="grey" icon @click="openDialog(item, index, 'edit')">
              <v-icon>fa-solid fa-ellipsis</v-icon>
            </v-btn>
          </v-row>
        </v-col>

        <v-fab-transition v-if="!ListBottomMenu">
          <v-btn class="mx-2" fab dark small fixed bottom right color="#2662ae" @click="openDialog('', '', 'create')">
            <v-icon dark>fa-solid fa-plus</v-icon>
          </v-btn>
        </v-fab-transition>

      </div>
    </v-card>
    <Warning :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog"/>
    <ErrorAlert :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>

    <ListBottomMenu :ListBottomMenu="ListBottomMenu" :ListBottomItem="ListBottomItem" @emitListBottom="emitListBottom" @closeAlertDialog="closeAlertDialog"/>
    <CreatedAlbums :AlbumsRoom="AlbumsRoom" :CreatedAlbumsDialog="CreatedAlbumsDialog" @emitComponents="emitComponents" :tokenuser="user_id" @closeComponents="closeComponents"/>
    <DetailAlbumsChat :AlbumsRoom="AlbumsRoom" :DetailAlbumsChatDialog="DetailAlbumsChatDialog" :DetailAlbumsDialog="DetailAlbumsDialog" :tokenuser="user_id" @emitComponents="emitComponents" @closeComponents="closeComponents"/>
    <EditNameAlbums :AlbumsRoom="AlbumsRoom" :EditAlbumsDialog="EditAlbumsDialog" :EditAlbumsDetail="EditAlbumsDetail" :tokenuser="user_id" @emitComponents="emitComponents" @closeComponents="closeComponents" />
    <AddImageAlbum :AlbumsRoom="AlbumsRoom" :AddImageAlbumsDialog="AddImageAlbumsDialog" :DetailAlbums="DetailAlbumsDialog" @emitComponents="emitComponents" @closeComponents="closeComponents" />
  </v-dialog>
</div>
</template>

<script>
import { Momenttime } from '@/services'
import Warning from '@/components/Alert/Warning'
import ErrorAlert from '@/components/Alert/Error'
import LinkPrevue from 'link-prevue'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import { vplayer, aplayer } from 'vue-hls-player'
import ListBottomMenu from '@/components/Alert/ListBottomMenu'
import EditNameAlbums from '@/components/EditNameAlbumsChat'
import CreatedAlbums from '@/components/CreatedAlbumsChat'
import DetailAlbumsChat from '@/components/DetailAlbumsChat'
import AddImageAlbum from '@/components/AddImageAlbumsChat'

var _ = require('lodash')
export default {
  props: {
    AlbumsDialog: Boolean,
    AlbumsRoom: String,
    tokenuser: String
  },
  data () {
    return {
      AddImageAlbumsDialog: false,
      EditAlbumsDialog: false,
      EditAlbumsDetail: {},
      detail_modal: {},
      date_image: '',
      progress_btm: false,
      activeKey: '',
      activeTabName: '',
      tokenroom: '',
      data_user: {},
      publicPath: process.env.VUE_APP_BASE_PATH,
      DetailAlbumsDialog: {},
      DetailAlbumsChatDialog: false,
      NoteDetail: {},
      CreatedAlbumsDialog: false,
      ListBottomMenu: false,
      ListBottomItem: [],
      ErrorDialog: false,
      ErrorDialogDetail: {},
      WarningDialog: false,
      WarningDialogDetail: {},
      list_image: [],
      list_file: [],
      list_link: [],
      status_edit: 'start',
      limit: 20,
      offset: 0,
      access_token: '',
      refresh_token: '',
      progress: false,
      nextgetMedia: true,
      thumbnail_video: '',
      muted_video: false,
      videoOptions: {
        autoplay: true,
        controls: true,
        muted: false,
        fullscreen: true,
      },
      pageCount: 1,
      page: null,
      numPages: 1,
      urlpdf: '',
      filenamepdf: '',
      sources_video: [],
      list_albums: [],
      offset: 0,
      stylechat: {
        "--AlbumsChat-HeaderColor": "white",
        "--AlbumsChat-TabBackground": "white",
        "--AlbumsChat-Icon": "gray",
        "--AlbumsChat-HeaderPictureBorderRadius": "6px",
        "--AlbumsChat-IconActive": "#2662ae",
        "--AlbumsChat-Background": "white",
        "--AlbumsChat-FontSize": "18px",
        "--AlbumsChat-FontSize-Title": "24px",
        "--AlbumsChat-FontColor": "back",
        "--AlbumsChat-FontSize-Status": "16px",
        "--AlbumsChat-FontColor-Status": "grey",
        "--AlbumsChat-Background-Input": "#E2E1E3",
        "--AlbumsChat-Color-Button": "#EFF2FE",
        "--AlbumsChat-FontColor-Button": "#2662ae",
        "--AlbumsChat-FontColor-Block-Button": "#cb1002",
        "--AlbumsChat-FontColor-Dis-Button": "#e2e1e3",
        "--AlbumsChat-Btn-Confirm-Background": "#2662ae",
        "--AlbumsChat-Btn-Confirm-Color": "white",
        "--AlbumsChat-Btn-Confirm-FontSize": "18px",
        "--AlbumsChat-Btn-Cancel-Background": "white",
        "--AlbumsChat-Btn-Cancel-Color": "#2662ae",
        "--AlbumsChat-Btn-Cancel-FontSize": "18px",
        "--AlbumsChat-Btn-Leave-Background": "white",
        "--AlbumsChat-Btn-Leave-Color": "#ff5252",
        "--AlbumsChat-Btn-Leave-FontSize": "18px",
        "--AlbumsChat-FontSize-Title-Edit": "20px"
      },
      user_id: "",
    }
  },
  components: {
    ErrorAlert,
    Warning,
    LinkPrevue,
    vplayer,
    aplayer,
    VuePdfEmbed,
    ListBottomMenu,
    EditNameAlbums,
    DetailAlbumsChat,
    CreatedAlbums,
    AddImageAlbum,
  },
  watch: {
    AlbumsDialog () {
      if (this.AlbumsDialog) {
        this.tokenroom = this.AlbumsRoom
        this.user_id = this.tokenuser
        // console.log('obj: ', this.tokenroom)
        this.access_token = this.$cookie.get('access_token')
        this.refresh_token = this.$cookie.get('refresh_token')
        this.offset = 0
        this.getAlbums()
      }
    },
  },
  created () {
    var user_profile = JSON.parse(this.$cookie.get('user-profile-private'))
    this.data_user = user_profile
    // this.tokenuser = this.data_user.business_user_id
    this.offset = 0
  },
  methods: {
    getAlbums () {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_EVENT + `/getlist_albums`, {
        tokenroom: this.tokenroom,
        tokenuser: this.tokenuser
      }).then((response) => {
        if (response.data.status == 'success') {
          this.progress = false
          this.list_albums = response.data.data
          // console.log(this.list_albums)
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        if (err.response.data.status === 401) {
          var data = {
            type: 'getAlbums',
            key: ''
          }
          // this.getNewAccess(this.access_token, this.refresh_token, data)
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      })
    },
    downloadFile(file, name) {
      // console.log(file)
      // console.log(name)
      this.axios.get(file, {
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
      })
    },
    handleDocumentRender() {
      // this.isLoading = false
      this.pageCount = this.$refs.myPdfComponent.pageCount
    },
    handlePasswordRequest(callback, retry) {
      callback(prompt(retry ?
        'Enter password again' :
        'This document is password protected. Please enter a password.'
      ))
    },
    openFilePDF (file) {
      // console.log(file)
      this.detail_modal = file
      this.urlpdf = file.path
      this.filenamepdf = file.name
      var modal = document.getElementById('myModalpdf')
      modal.style.display = 'block'
    },
    zoom (item) {
      // console.log(item)
      this.detail_modal = item
      if (item.type == 'image') {
        var modal = document.getElementById('myModalImage')
        var modalImg = document.getElementById('img01')
        modal.style.display = 'block'
        modalImg.src = item.path
      } else {
        var modalVideo = document.getElementById('myModalVideo')
        // var modalVideo = document.getElementById('video01')
        modalVideo.style.display = 'block'
        this.thumbnail_video = item.detail.thumbnail
        this.muted_video = true
        this.sources_video = [item.detail.m3u8_path]
        // console.log(this.sources_video)
        this.videoOptions = {
          autoplay: false,
          controls: true,
          muted: false,
          userActions: {
            click: false
          }
        }
      }
    },
    closemodal () {
      this.detail_modal = ''
      var modal = document.getElementById('myModalImage')
      modal.style.display = 'none'
      var modalpdf = document.getElementById('myModalpdf')
      modalpdf.style.display = 'none'

      this.thumbnail_video = ''
      this.muted_video = true
      // console.log(this.muted_video)
      this.videoOptions = {
        autoplay: false,
        controls: false,
        muted: true
      }
      // this.sources_video = []
      var modalvideo = document.getElementById('myModalVideo')
      modalvideo.style.display = 'none'
      // modalvideo.remove()
      // document.getElementById("my-element").remove()
      // console.log(this.videoOptions)
    },
    clicklink_website(url) {
      // this.checkBrowser(url, '')
      window.open(url, '_blank')
    },
    convertURL(msg) {
      var urlRegex = /\bhttps?:\/\/\S+/gi;
      var linkmsg = msg.match(urlRegex)
      if (linkmsg !== null) {
        if (linkmsg.length !== 0) {
          linkmsg.length = 1
          return linkmsg
        }
        return ''
      } else {
        return ''
      }
    },
    extension (path) {
      var extension = path.split('.')[path.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var spreadsheet = ['xls', 'xlsx', 'xlt', 'xlsm', 'xlm', 'xlsm', 'gsheet']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff']
      var media = ['mpg', 'mpeg', 'avi', 'wmv', 'mov', 'rm', 'ram', 'swf', 'flv', 'ogg', 'webm', 'mp4']
      var audio = ['mp3', 'wma', 'aac', 'ogg', 'm4a', 'wav', 'cda', 'flac', 'aiff', 'caf']
      if (pdf.includes(extension)) {
        return 'fa-solid fa-file-pdf'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else if (media.includes(extension)) {
        return 'fa-solid fa-file-video'
      } else if (audio.includes(extension)) {
        return 'fa-solid fa-file-audio'
      } else {
        return 'fas fa-file-alt'
      }
    },
    scrollFunction () {
      // var scroll = this.$el.querySelector('#myscrollAlbumChatNote')
      var scroll = document.getElementById("myscrollAlbumChat")
      // console.log(scroll.scrollTop)
      if (scroll !== null && scroll !== 'null') {
        if((scroll.scrollTop + scroll.clientHeight) >= (scroll.scrollHeight * 0.6)) {
          // this.getAlbums()
        } else {
          if (scroll.scrollTop === 0) {
            this.offset = 0
          }
        }
      }
    },
    emitListBottom (value) {
      // console.log(value)
      this.ListBottomMenu = false
      if (value.item.actions === 'delete-album') {
        this.openDialog(value.item, value.item.index, 'delete-album')
      } else if (value.item.actions === 'edit-album') {
        this.EditAlbumsDetail = value.item.item
        this.EditAlbumsDialog = true
      } else if (value.item.actions === 'add-image') {
        this.DetailAlbumsDialog = value.item.item
        this.AddImageAlbumsDialog = true
      }
    },
    emitComponents (value) {
      // console.log(value)
      if (value.name === 'create-album') {
        this.CreatedAlbumsDialog = false
        // this.getNote()
        this.list_image.unshift(value.item)
        this.list_image = _.unionBy(this.list_image, 'note_id')
        this.list_image = _.orderBy(this.list_image, 'updated_at', 'desc')
      } else if (value.name === 'detail-note') {
        this.DetailAlbumsDialog = false
        // this.getNote()
      } else if (value.name === 'edit-album') {
        this.offset = 0
        // this.list_image = []
        this.EditAlbumsDetail = {}
        this.EditAlbumsDialog = false
        this.getAlbums()
      } else if (value.name === 'delete-album') {
        this.DetailAlbumsDialog = false
        var index = _.findIndex(this.list_albums, function(o) { return o.album_id === value.item.id })
        if (index !== -1) {
          this.list_albums.splice(index, 1)
        }
      }
    },
    openDialog (item, index, type) {
      console.log(item)
      // console.log(type)
      if (type === 'create') {
        this.CreatedAlbumsDialog = true
      } else if (type === 'edit') {
        this.ListBottomItem = [
          {
            text: this.$t('Dialog.album.btnAddImage'),
            icon: 'fa-solid fa-image',
            actions: 'add-image',
            id: item._id,
            index: index,
            item: item
          },
          {
            text: this.$t('Dialog.album.btnEdit'),
            icon: 'fa-solid fa-pen-to-square',
            actions: 'edit-album',
            id: item._id,
            index: index,
            item: item
          },
          {
            text: this.$t('Dialog.album.btnRemoveAlbum'),
            icon: 'fa-solid fa-trash-can',
            actions: 'delete-album',
            id: item._id,
            index: index
          }
        ]
        this.ListBottomMenu = true
      } else if (type === 'delete-album') {
        this.WarningDialogDetail = {
          title: this.$t('Alert.Sure'),
          text: this.$t('Alert.Album.deleteAlbum'),
          detail: item,
          index: index,
          type: 'delete-album'
        }
        this.WarningDialog = true
      } else if (type === 'detail-album') {
        // เอาไว้เช็คตอนกดปุ่มไอคอน list ว่าจะให้ปิดหน้ารายการโน้ตหรือให้แสดงอันใหม่ กรณีที่อยู่ในหน้าแชทหรือในหน้าโน้ต
        item.previous = 'list-album'
        item.album_id = item._id;
        this.DetailAlbumsDialog = item
        this.DetailAlbumsChatDialog = true
      }
    },
    date (timestamp) {
      if (this.$cookie.get('language') === null || this.$cookie.get('language') === 'undefined') {
        return Momenttime.dayjsdatethai(timestamp)
      } else {
        if (this.$cookie.get('language') === 'th') {
          return Momenttime.dayjsdatethai(timestamp)
        } else {
          return Momenttime.dayjsdateen(timestamp)
        }
      }
    },
    time (timestamp) {
      if (this.$cookie.get('language') === 'th') {
        return Momenttime.dayjstimethai(timestamp)
      } else {
        return Momenttime.dayjstimethai(timestamp)
      }
    },
    close () {
      this.offset = 0
      this.list_albums = []
      this.$emit('closeComponents', {
        name: 'albumschat',
        value: false
      })
    },
    emitWarning (item) {
      // console.log(item)
      this.WarningDialog = false
      if (item.type === 'delete-album') {
        this.deleteAlbum(item.detail.id, item.index)
      }
    },
    closeComponents (data) {
      // console.log(data)
      if (data.name === 'create-album') {
        this.CreatedAlbumsDialog = data.value
        this.offset = 0
        this.getAlbums()
      } else if (data.name === 'edit-album') {
        this.EditAlbumsDialog = data.value
        this.offset = 0
        this.getAlbums()
      } else if (data.name === 'detail-album') {
        this.DetailAlbumsChat = {}
        this.DetailAlbumsChatDialog = data.value
        this.offset = 0
        this.getAlbums()
      } else if (data.name === 'delete-album') {
        this.DetailAlbumsDialog = {}
        this.DetailAlbumsChatDialog = data.value
        this.offset = 0
        this.getAlbums()
      } else if (data.name === 'add-image') {
        this.AddImageAlbumsDialog = false
        this.offset = 0
        this.getAlbums()
      }
    },
    closeAlertDialog (data) {
      // console.log(data)
      if (data.type === 'warning') {
        this.WarningDialog = data.value
      } else if (data.type === 'err') {
        this.ErrorDialog = data.value
      } else if (data.type === 'bottommenu') {
        this.ListBottomMenu = data.value
      }
    },
    deleteAlbum (id, index) {
      this.progress = true
      var body = {
        albums_id: id,
        tokenuser: this.tokenuser,
        tokenroom: this.tokenroom
      }
      this.axios.post(process.env.VUE_APP_API_EVENT + `/delete_albums`, body, {
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.list_albums.splice(index, 1)
          // console.log(this.list_image)
        } else {
          this.progress = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        if (err.response.data.status === 401) {
          var item = {
            type: 'deleteAlbums',
            key: {
              album_id: id,
              album_index: index
            }
          }
          // this.getNewAccess(this.access_token, this.refresh_token, item)
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      })
    },
    getListImage () {
      if (this.nextgetMedia) {
        if (this.offset == 0) {
          this.progress = true
        } else {
          this.progress_btm = true
        }
        this.axios.get(process.env.VUE_APP_API_PRIVATE + `/v1/chats/${this.tokenroom}/media?limit=${this.limit}&offset=${this.offset}`, {
          headers: { Authorization: `Bearer ${this.access_token}` }
        }).then((response) => {
          if (response.data.status === 200) {
            this.progress = false
            this.progress_btm = false
            // console.log(response.data.data)
            if (response.data.data.length === 20) {
              this.nextgetMedia = true
            } else {
              this.nextgetMedia = false
            }
            this.offset = this.offset + 1

            this.list_image.push.apply(this.list_image, response.data.data)
            this.list_image = _.unionBy(this.list_image, 'message_id')
            // this.list_image = _.orderBy(this.list_image, 'updated_at', 'desc')
            // console.log(this.list_image)
            // this.date_image = response.data.data[0].timestamp
          } else {
            this.progress = false
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.progress = false
          if (err.response.data.status === 401) {
            var item = {
              type: 'getListNote',
              key: ''
            }
            this.getNewAccess(this.access_token, this.refresh_token, item)
          } else {
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        })
      }
    },
    getListFile () {
      if (this.nextgetMedia) {
        if (this.offset == 0) {
          this.progress = true
        } else {
          this.progress_btm = true
        }
        this.axios.get(process.env.VUE_APP_API_PRIVATE + `/v1/chats/${this.tokenroom}/files?limit=${this.limit}&offset=${this.offset}`, {
          headers: { Authorization: `Bearer ${this.access_token}` }
        }).then((response) => {
          if (response.data.status === 200) {
            this.progress = false
            this.progress_btm = false
            // console.log(response.data.data)
            if (response.data.data.length === 20) {
              this.nextgetMedia = true
            } else {
              this.nextgetMedia = false
            }
            this.offset = this.offset + 1

            this.list_file.push.apply(this.list_file, response.data.data)
            this.list_file = _.unionBy(this.list_file, 'message_id')
            // this.list_image = _.orderBy(this.list_image, 'updated_at', 'desc')
            // console.log(this.list_file)
            // this.date_image = response.data.data[0].timestamp
          } else {
            this.progress = false
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.progress = false
          if (err.response.data.status === 401) {
            var item = {
              type: 'getListFile',
              key: ''
            }
            this.getNewAccess(this.access_token, this.refresh_token, item)
          } else {
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        })
      }
    },
    getListLink () {
      if (this.nextgetMedia) {
        if (this.offset == 0) {
          this.progress = true
        } else {
          this.progress_btm = true
        }
        this.axios.get(process.env.VUE_APP_API_PRIVATE + `/v1/chats/${this.tokenroom}/links?limit=${this.limit}&offset=${this.offset}`, {
          headers: { Authorization: `Bearer ${this.access_token}` }
        }).then((response) => {
          if (response.data.status === 200) {
            this.progress = false
            this.progress_btm = false
            // console.log(response.data.data)
            if (response.data.data.length === 20) {
              this.nextgetMedia = true
            } else {
              this.nextgetMedia = false
            }
            this.offset = this.offset + 1

            this.list_link.push.apply(this.list_link, response.data.data)
            this.list_link = _.unionBy(this.list_link, 'message_id')
            // this.list_image = _.orderBy(this.list_image, 'updated_at', 'desc')
            // console.log(this.list_file)
            // this.date_image = response.data.data[0].timestamp
          } else {
            this.progress = false
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.progress = false
          if (err.response.data.status === 401) {
            var item = {
              type: 'getListLink',
              key: ''
            }
            this.getNewAccess(this.access_token, this.refresh_token, item)
          } else {
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        })
      }
    },
    getNewAccess (oldaccess, oldrefresh, data) {
      var body = {
        access_token: oldaccess,
        refresh_token: oldrefresh
      }
      this.axios.post(process.env.VUE_APP_API_PRIVATE + `/v1/renew-access-token`, body, {
      }).then((response) => {
        if (response.data.status === 200) {
          // console.log(response.data.data)
          this.access_token = response.data.data.access_token
          this.refresh_token = response.data.data.refresh_token
          this.$cookie.set('access_token', response.data.data.access_token)
          this.$cookie.set('refresh_token', response.data.data.refresh_token)
          if (data.type === 'getAlbums') {
            this.getAlbums()
          } else if (data.type === 'deleteAlbum') {
            this.deleteAlbum(data.key.album_id, data.key.album_index)
          }
        }
      }).catch(err => {
        // console.log(err)
        console.log(err.response.data)
      })
    },
  }
}
</script>

<style lang="css" scoped>
.cursor {
  cursor: pointer;
}
.col-no-media-not-active {
  border-style: solid;
  border-width: thin;
  border-radius: 15px;
  background-color: #8080801c;
  border-color: #8080801c;
  height: 170px;
  align-items: center;
  justify-content: center;
  display: flex;
  /* color: #d7d7d7; */
  color: #818181;
}
.color-white {
    color: white !important;
}
.fz-20 {
  font-size: 20px !important;
}
>>>.player__controls--progress {
  flex: 1 !important;
  margin: 0 8px !important;
  z-index: 0 !important;
}
>>>.aplayer .player__controls--durration {
  color: rgb(0 0 0) !important;
}
>>>.video-js {
  display: block;
  vertical-align: top;
  box-sizing: border-box;
  color: #fff;
  background-color: #000;
  position: relative;
  padding: 0;
  font-size: 10px;
  line-height: 1;
  font-weight: 400;
  font-style: normal;
  font-family: Arial,Helvetica,sans-serif;
  word-break: initial;
  /* height: 100% !important; */
  width: 100% !important;
}
.modalc {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 1;
    /* Sit on top */
    left: 0;
    top: 0;
    width: 100vw;
    /* Full width */
    height: 100vh;
    /* Full height */
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.9);
    /* Black w/ opacity */
}

.modal-contentc {
    padding-top: 10vh;
    margin: auto;
    display: block;
    max-width: 95%;
    max-height: 80%;
}

#headcaption {
    margin: auto;
    display: block;
    text-align: left;
    color: #fff;
    padding-top: 1vh;
    padding-bottom: 1vh;
    background-color: var(--AlbumsChat-HeaderPictureBorderRadius) !important;
}
.height-80vh {
  height: 80vh;
  overflow: hidden;
}
.col-no-media {
  border-style: solid;
  border-width: thin;
  border-radius: 15px;
  background-color: #8080801c;
  border-color: #8080801c;
  height: 100px;
  align-items: center;
  justify-content: center;
  display: flex;
  color: gray;
}
.text-overflow-link {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 60vw;
}
>>>.v-list-item .v-list-item__title {
  line-height: 2.0 !important;
}
.fz-19 {
  font-size: 19px;
}
.fw-600 {
  font-weight: 600;
}
.centerimg_website {
  justify-content: center;
  display: flex;
  margin-bottom: 10px;
}
.img_website {
  height: 50px;
  width: 50px;
  margin: auto;
  border-radius: 10px;
  object-fit: cover;
}
.layout-panels {
  height: calc(100vh - 140px) !important;
  /* height: 210px; */
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.layout-panels::-webkit-scrollbar {
  width: 3px;
}

.layout-panels::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}

>>>.ant-tabs-nav .ant-tabs-tab-active {
  color: var(--AlbumsChat-IconActive) !important;
  text-shadow: 0 0 0.25px currentColor !important;
}
>>>.ant-tabs-ink-bar {
  position: absolute;
  bottom: 1px;
  left: 0;
  z-index: 0;
  box-sizing: border-box;
  height: 2px;
  background-color: var(--AlbumsChat-IconActive) !important;
  transform-origin: 0 0;
}
.font-list-title {
  font-weight: 600;
  color: var(--AlbumsChat-FontColor) !important;
}
.width-100 {
  width: 100% !important;
}
.fz-30 {
  font-size: 30px !important;
}
.fz-50 {
  font-size: 50px !important;
}
.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--AlbumsChat-FontSize-Title) !important;
  color: var(--AlbumsChat-FontColor) !important;
  font-weight: 600;
}
.text-title-edit {
  font-size: var(--AlbumsChat-FontSize-Title-Edit) !important;
  color: var(--AlbumsChat-FontColor) !important;
}
.tab-title {
  color: var(--AlbumsChat-FontColor) !important;
  font-size: var(--AlbumsChat-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--AlbumsChat-FontColor-Status) !important;
  font-size: var(--AlbumsChat-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 50vw;
}
.text-overflow-modal {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
}
.checkbox-color {
  color: var(--AlbumsChat-IconActive) !important;
}
>>>.v-application .elevation-10 {
  box-shadow: none !important;
}
>>>.theme--light.v-sheet {
  box-shadow: none !important;
}
.list-overflow {
  height: calc(100vh - 64px) !important;
  overflow-y: scroll;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow::-webkit-scrollbar {
  width: 3px;
}

.list-overflow::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}

.list-overflow-select {
  height: calc(100vh - 210px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow-select::-webkit-scrollbar {
  width: 3px;
}

.list-overflow-select::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}
/* >>>.v-input__slot {
  background-color: var(--AlbumsChat-Background-Input) !important;
  border-radius: 10px !important;
} */
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
  background-color: var(--AlbumsChat-Background-Input) !important;
  border-radius: 10px !important;
}
>>>.v-dialog--fullscreen {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: fixed;
  /* overflow-y: auto; */
  top: 0;
  left: 0;
  overflow: hidden;
}
>>>.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.icon-color-edit {
  color: var(--AlbumsChat-Icon) !important;
}
.icon-color {
  color: var(--AlbumsChat-IconActive) !important;
}
.btn-confirm {
  background-color: var(--AlbumsChat-Btn-Confirm-Background) !important;
  color: var(--AlbumsChat-Btn-Confirm-Color) !important;
  font-size: var(--AlbumsChat-Btn-Confirm-FontSize) !important;
  font-weight: 600;
}
.btn-cancel {
  background-color: var(--AlbumsChat-Btn-Cancel-Background) !important;
  color: var(--AlbumsChat-Btn-Cancel-Color) !important;
  font-size: var(--AlbumsChat-Btn-Cancel-FontSize) !important;
  font-weight: 600;
}
.btn-leave {
  background-color: var(--AlbumsChat-Btn-Leave-Background) !important;
  color: var(--AlbumsChat-Btn-Leave-Color) !important;
  font-size: var(--AlbumsChat-Btn-Leave-FontSize) !important;
  font-weight: 600;
}
.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}
.layout-page {
  /* height: calc(100vh - 64px) !important; */
  height: 100vh !important;
  overflow: hidden !important;
  background-color: var(--AlbumsChat-Background) !important;
}

.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--AlbumsChat-FontSize-Title) !important;
  color: var(--AlbumsChat-FontColor) !important;
  font-weight: 600;
}
.tab-title {
  color: var(--AlbumsChat-FontColor) !important;
  font-size: var(--AlbumsChat-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--AlbumsChat-FontColor-Status) !important;
  font-size: var(--AlbumsChat-FontSize-Status) !important;
}
/* .text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
} */
</style>
